import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { PageHeader } from "../components/ui-bits";
import { FileList } from "../components/FileList";

export default function Files() {
  const [projects, setProjects] = useState([]);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/projects");
        setProjects(data);
      } catch {}
    })();
  }, []);

  return (
    <div className="animate-fade-up" data-testid="files-page">
      <PageHeader overline="Ablage" title="Dateien" testid="files-header" />
      <FileList projects={projects} />
    </div>
  );
}
